import React, {Component} from "react";
import {Row} from "../../components/Layout";

import {projects} from "../../constants";

import styles from "./projectType.module.scss";

let classNames = require('classnames');

export class ProjectTypePage extends Component {
	state = {};

	onClick(projectType) {
		let p = this.props.projects.filter(p => p.projectTypeName === projectType.name);
		if(p.length === 1) {
			this.props.setProject(p[0]);
		}
		this.props.filter(projectType)
	}

	render() {
		return <Row>
			{
				projects.types.filter(t => !t.hidden).map(type =>{
					let disabled = !this.props.projects.find(p => p.projectTypeName === type.name);
					return <div className={classNames(styles.col)} key={type.name}>
						<div
							onClick={(e) => disabled ? e.preventDefault() : this.onClick(type)}
							className={classNames(styles.col, styles.button, {[styles.disabled]:disabled})}
							onMouseOver={() => disabled ? null : this.setState({isHover:type.name}) }
							onMouseOut={() => disabled ? null : this.setState({isHover:null})}
						>
							<div className={styles.imageContainer}>
								<img alt={type.name} src={this.state.isHover === type.name ? type.iconHover : type.icon}/>
							</div>
							<div>{type.name}</div>
						</div>
						<div className={styles.link}>
							{type.link}
						</div>
					</div>
				})
			}
		</Row>
	}
}
